module.exports = __webpack_public_path__ + "static/media/coforge.786d9d2d.jpeg";